import { FixedLineItemSchema, PricingSchema } from '@weft/types';
import { oz } from '@weft/utils';

// TODO: remove this since we have the data on lineItemProduct property in the lineItem
export const LightInvoiceFixedLineItemSchema = FixedLineItemSchema.pick({
  id: true,
  price: true,
  modifiedName: true,
}).extend({
  pricing: PricingSchema,
  productName: oz.string(),
  productId: oz.string().optional(),
  description: oz.string().optional(),
});

export type LightInvoiceFixedLineItem = oz.TypeOf<typeof LightInvoiceFixedLineItemSchema>;